{
  "pages": [
    {
      "name": "Booster",
      "elements": [
        {
          "type": "panel",
          "name": "panel1",
          "elements": [
            {
              "type": "text",
              "name": "title",
              "title": "System name"
            },
            {
              "type": "text",
              "name": "NumberOfPumps",
              "isRequired": true,
              "title": "Number of Pumps",
              "inputType": "number"
            }
          ]
        }
      ]
    }
  ]
}